// extracted by mini-css-extract-plugin
module.exports = {"table":"link-grid_table__Jq2V_","more-columns":"link-grid_more-columns__46vp_","wrapper":"link-grid_wrapper__IMRtV"};